import React from 'react';
import {
  VirtualTourLink,
  DownloadApp,
} from 'iovisit-museum-theme/components/Views';

const PageActionsExternalLink = ({
  content,
  showDownloadApp = false,
  showLabel = true,
}) => {
  return content ? (
    <div className="page-actions-external-link">
      {showDownloadApp && (
        <DownloadApp content={content} showLabel={showLabel} />
      )}

      <VirtualTourLink content={content} showLabel={showLabel} />
    </div>
  ) : (
    <></>
  );
};
export default PageActionsExternalLink;
